import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedTab: 0,
    viewCompany: null,
    selectedUser: null,
    selectedCompanyForEdit: null,
    alertForAdminUpdations: null,
};

const SuperAdminSlice = createSlice({
    name: "superAdmin",
    initialState,
    reducers: {
        setSelectedTab: (state, actions) => {
            state.selectedTab = actions.payload;
        },
        setviewCompany: (state, actions) => {
            state.viewCompany = actions.payload;
        },
        setSelectedUser: (state, actions) => {
            state.selectedUser = actions.payload;
        },
        setSelectedCompanyForEdit: (state, actions) => {
            state.selectedCompanyForEdit = actions.payload;
        },
        setAlertForAdminUpdations: (state, actions) => {
            state.alertForAdminUpdations = actions.payload;
        },
    }
});

export const {
    setSelectedTab,
    setSelectedUser,
    setviewCompany,
    setSelectedCompanyForEdit,
    setAlertForAdminUpdations
} = SuperAdminSlice.actions;

export default SuperAdminSlice.reducer;